import axios from "axios"
import { TallyConfig } from "../helpers/constants"
import { xmlToJs } from "../helpers/xmltojs"
import { xmlFormatter } from "../helpers/xmlFormatter"
import { userSignal } from "../../../../signal/userSignal"

export async function GetGroups(sync) {

    let data = `
        <ENVELOPE>
            <HEADER>
                <VERSION>1</VERSION>
                <TALLYREQUEST>EXPORT</TALLYREQUEST>
                <TYPE>COLLECTION</TYPE>
                <ID>List of Groups</ID>
            </HEADER>
            <BODY>
                <DESC>
                    <STATICVARIABLES>
                        <SVCURRENTCOMPANY>${TallyConfig.company}</SVCURRENTCOMPANY>
                        <SVEXPORTFORMAT>$$SysName:XML</SVEXPORTFORMAT>
                    </STATICVARIABLES>
                </DESC>
            </BODY>
        </ENVELOPE>
    `

    data = xmlFormatter(data)

    try {

        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data
        })
        if (resp.status === 200) {
            let jsonData = resp?.data

            let groups = jsonData?.ENVELOPE?.BODY?.DATA?.COLLECTION?.GROUP || []

            if (!(groups instanceof Array)) {
                groups = [groups]
            }

            let sundryDebtorsGrps = []
            let salesLedgersGrps = []
            let taxesLedgersGrps = []
            let bankAccountsGrps = []

            let parentMap = {}

            groups.forEach((group) => {
                if (group?.PARENTSTRUCTURE?._text?.includes("Sundry Debtors")) {
                    sundryDebtorsGrps.push(group?._attributes?.NAME?.trim())
                    if (group?._attributes?.NAME?.trim() !== "Sundry Debtors") {
                        let temp = parentMap[group?.PARENT?._text?.trim()] || []
                        temp.push(group?._attributes?.NAME?.trim())
                        parentMap[group?.PARENT?._text?.trim()] = temp
                    }
                } else if (group?.PARENTSTRUCTURE?._text?.includes("Sales Accounts")) {
                    salesLedgersGrps.push(group?._attributes?.NAME?.trim())
                } else if (group?.PARENTSTRUCTURE?._text?.includes("Duties & Taxes")) {
                    taxesLedgersGrps.push(group?._attributes?.NAME?.trim())
                } else if (group?.PARENTSTRUCTURE?._text?.includes("Bank Accounts")) {
                    bankAccountsGrps.push(group?._attributes?.NAME?.trim())
                }
            })

            window.localStorage.setItem(`tally-${TallyConfig.company}-groups`, JSON.stringify({
                sundryDebtorsGrps,
                salesLedgersGrps,
                taxesLedgersGrps,
                bankAccountsGrps
            }))

            if (!sync) {
                return jsonData
            }

            function buildGroupTree(groupName) {
                const group = {
                  name: groupName,
                  children: []
                };
              
                // If the group has children in the parentMap, recurse for each child
                if (parentMap[groupName]) {
                  group.children = parentMap[groupName].map(child => buildGroupTree(child));
                }
              
                return group;
            }

            

            const grps = buildGroupTree("Sundry Debtors");

            let res = await window.electron.grpcConnect({
                userId: userSignal?.value?.user.id,
                organisationId: userSignal?.value?.user?.organisation,
                reqType: "syncGroups",
                dealers: JSON.stringify(grps),
            })

            

            // wait for 2s
            await new Promise((resolve, reject) => {
                setTimeout(async () => {
                    resolve()
                }, 5000)
            })

            return jsonData
        } else {
            console.log(resp)
            return false
        }
    } catch (err) {
        console.log(err)
        return false
    }
}

